import States from "../Lists/States";

export default function GetFullState(state) {
  if (!state) {
    return '';
  }
  else {
    let stateName = States().find(x => x.value === state);
    if (!stateName) {
      return state;
    }
    else {
      return stateName.label;
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/GetFullState.js